export default __webpack_public_path__ + "static/media/IMG_4563-min.2fc2e0ba.JPG";